import { CFMixins } from '../../../../mixins';
import { BORDER_COLOR, ROOT_COLOR, ROOT_SIZE, TEXT_COLOR, TYPE_SPEC, } from './tokens';
export const rootBorderColor = ({ colorway, strength, }) => BORDER_COLOR[colorway][strength];
export const rootColor = ({ colorway, strength }) => ROOT_COLOR[colorway][strength];
export const rootSize = ({ size }) => ROOT_SIZE[size];
export const textColor = ({ colorway, strength }) => TEXT_COLOR[colorway][strength];
export const typeSpec = ({ size }) => CFMixins.typeSpec(TYPE_SPEC[size]);
